import snowflake from "../../../../assets/images/datastore_snowflake.png";
import postgres from "../../../../assets/images/postgres.png";
import s3 from "../../../../assets/images/s3_bucket.png";
import mySQL from "../../../../assets/images/my_sql.png";
import tableau from "../../../../assets/images/tableau.svg";
import bigQuery from "../../../../assets/images/big_query.png";
import dbt from "../../../../assets/icons/dbt.svg";
import databricks from "../../../../assets/images/databricks.svg";
import { capitalize, lowerCase } from "lodash";
import DatastoreTypeIcons from "@/pages/datastores/DatastoreTypeIcons";
import { DatastoreType } from "../../types";

export const GET_DATASTORE_TYPES = "GET-DATASTORE-TYPES";

const iconMap: Record<string, string> = {
  postgres,
  snowflake,
  s3,
  bigquery: bigQuery,
  mysql: mySQL,
  tableau: tableau,
  dbtcloud: dbt,
  dbtcore: dbt,
  azuredatabricks: databricks,
  azuredatabricksprivatelink: databricks,
  databricks,
};

interface IconProps {
  datastoreType: DatastoreType;
  className?: string;
}

export const getIconByDatastoreType = ({
  datastoreType,
  className,
}: IconProps): JSX.Element | null => {
  const icon = iconMap[lowerCase(datastoreType).replace(/ /g, "")];
  if (!icon) return null;

  return <img src={icon} alt={capitalize(datastoreType)} className={className} />;
};

export { DatastoreTypeIcons };
